import { useGetXstyledProps, useGetGlobalAttributes } from '@elliemae/ds-props-helpers';
import React from 'react';
import { uid } from 'uid';
import { defaultProps, type DSFloatingWrapperT } from '../react-desc-prop-types.js';

export interface DSFloatingWrapperCTX {
  propsWithDefault: DSFloatingWrapperT.InternalProps;
  xstyledProps: ReturnType<typeof useGetXstyledProps>;
  globalsAttrs: ReturnType<typeof useGetGlobalAttributes>;
  instanceUid: string;
}

export const useFloatingWrapper = (propsFromUser: DSFloatingWrapperT.Props) => {
  // =============================================================================
  // MERGE WITH DEFAULT AND VALIDATE PROPS
  // =============================================================================
  // the floating context contains various HTML DOM elements
  //  Deep compare of HTML DOM elements is pointless and extremely costly
  //  for this specific case, we are better of not using `useMemoMergePropsWithDefault`
  const propsWithDefault = React.useMemo(
    () => ({
      ...defaultProps,
      ...propsFromUser,
    }),
    [propsFromUser],
  ) as DSFloatingWrapperT.InternalProps;
  // useValidateProps(propsWithDefault, DSFloatingWrapperPropTypes);
  // =============================================================================
  // XSTYLED AND GLOBALS PROPS
  // =============================================================================
  const xstyledProps = useGetXstyledProps(propsWithDefault);

  const globalsAttrs = useGetGlobalAttributes(propsWithDefault);
  // =============================================================================
  // AD HOC PER COMPONENT LOGIC
  // =============================================================================
  // custom code goes here, this is an example
  const instanceUid = React.useMemo(() => uid(5), []);
  // =============================================================================
  // HELPERS HOOKS CONFIGS
  // =============================================================================
  // const eventHandlers = useEventHandlers({ propsWithDefault, instanceUid }); // <-- complex logic should be made atomics this way

  return React.useMemo(
    () => ({
      propsWithDefault,
      xstyledProps,
      instanceUid,
      globalsAttrs,
      // ...eventHandlers,
    }),
    [
      propsWithDefault,
      xstyledProps,
      instanceUid,
      globalsAttrs,
      // eventHandlers,
    ],
  );
};
